function fnHeaderPrimary(iIndex, oBlock) {
	oBlock = $(oBlock)

	let iScrollTop = $(window).scrollTop(),
	iTempScrollTop = 0,
	fnScroll = () => {
		if(iScrollTop <= 0) iScrollTop = 0

		if(iScrollTop > 50) {
			oBlock.addClass('scrolled')
		} else {
			oBlock.removeClass('scrolled')
		}

		if(iScrollTop > iTempScrollTop) {
			oBlock.addClass('hide-header')
		} else {
			oBlock.removeClass('hide-header')
		}

		iTempScrollTop = iScrollTop
	}

	fnScroll()

	$(window).on('scroll', function() {
		iScrollTop = $(window).scrollTop()
		
		fnScroll()
	})

	if(typeof window.SmoothScroll !== 'undefined') {
		window.SmoothScroll.addListener(function(status) {
			iScrollTop = status.offset.y
			
			fnScroll()
		})
	}


}